var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('ContentSlotsDistributor', {
    attrs: {
      "slot-key": _vm.$parent.slotKey
    }
  }, [_c('p', [_vm._v("test::nginx 是openresty的一个测试框架，使用perl语言编写，测试用例使用DSL语法，可以穿插perl脚本。")]), _vm._v(" "), _c('p', [_vm._v("test::nginx 依赖perl环境，需要先安装perl语言的包管理器 cpanminus")]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "cpanminus-安装"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#cpanminus-安装"
    }
  }, [_vm._v("#")]), _vm._v(" cpanminus 安装")]), _vm._v(" "), _c('p', [_vm._v("安装文档："), _c('a', {
    attrs: {
      "href": "https://metacpan.org/pod/App::cpanminus#INSTALLATION",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://metacpan.org/pod/App::cpanminus#INSTALLATION"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("curl")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-L")]), _vm._v(" https://cpanmin.us "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("|")]), _vm._v(" perl - "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("--sudo")]), _vm._v(" App::cpanminus\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# or")]), _vm._v("\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("curl")]), _vm._v(" "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("-L")]), _vm._v(" https://cpanmin.us "), _c('span', {
    pre: true,
    attrs: {
      "class": "token operator"
    }
  }, [_vm._v("|")]), _vm._v(" perl - App::cpanminus\n\n"), _c('span', {
    pre: true,
    attrs: {
      "class": "token comment"
    }
  }, [_vm._v("# MacOS with brew")]), _vm._v("\nbrew "), _c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("install")]), _vm._v(" cpanminus\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("2")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("3")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("4")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("5")]), _c('br'), _c('span', {
    staticClass: "line-number"
  }, [_vm._v("6")]), _c('br')])]), _c('h2', {
    attrs: {
      "id": "通过-cpanm-安装-test-nginx模块"
    }
  }, [_c('a', {
    staticClass: "header-anchor",
    attrs: {
      "href": "#通过-cpanm-安装-test-nginx模块"
    }
  }, [_vm._v("#")]), _vm._v(" 通过 cpanm 安装 test::nginx模块")]), _vm._v(" "), _c('p', [_vm._v("安装文档："), _c('a', {
    attrs: {
      "href": "https://github.com/openresty/test-nginx#installation",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("https://github.com/openresty/test-nginx#installation"), _c('OutboundLink')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "language-bash line-numbers-mode"
  }, [_c('pre', {
    pre: true,
    attrs: {
      "class": "language-bash"
    }
  }, [_c('code', [_c('span', {
    pre: true,
    attrs: {
      "class": "token function"
    }
  }, [_vm._v("sudo")]), _vm._v(" cpanm "), _c('span', {
    pre: true,
    attrs: {
      "class": "token parameter variable"
    }
  }, [_vm._v("--notest")]), _vm._v(" Test::Nginx IPC::Run\n")])]), _vm._v(" "), _c('div', {
    staticClass: "line-numbers-wrapper"
  }, [_c('span', {
    staticClass: "line-number"
  }, [_vm._v("1")]), _c('br')])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };